const getBaseApiUrl = () => {
  const hostname = window.location.hostname;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:5005/api/v1';
  } else if (hostname.includes('staging')) {
    return 'https://staging-api.mattertrafficmanager.com/api/v1';
  } else {
    return 'https://api.mattertrafficmanager.com/api/v1';
  }
};

const baseUrl = getBaseApiUrl();
const useAppDb = true;

export const config = {
  // Base API URL for auth routes (login, refresh, etc.)
  API_BASE_URL: baseUrl,
  // Data API URL (app-db when feature flag is enabled)
  API_URL: useAppDb ? `${baseUrl}/app-db` : baseUrl,
  USE_APP_DB: useAppDb,
  APP_ENV: window.location.hostname === 'localhost' ? 'development' : 'production',
};
